import { PlusIcon } from "@vetty/icons";
import { Button, Tabs, TabsItem } from "@/components";
import {
  MODEL_LIBRARY_FILTER_ITEMS,
  type ModelsLibraryFilter,
} from "../../_constants/models-library-toolbar.const";
import styles from "./ModelsLibraryToolbar.module.scss";

type ModelsLibraryToolbarProps = {
  filter: ModelsLibraryFilter;
  onFilterChange: (value: ModelsLibraryFilter) => void;
  onAddModelClick?: () => void;
};

export const ModelsLibraryToolbar = ({
  filter,
  onFilterChange,
  onAddModelClick,
}: ModelsLibraryToolbarProps) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__left"]}>
        <Tabs
          value={filter}
          onChange={(value) => onFilterChange(value as ModelsLibraryFilter)}
          variant="secondary"
          size="medium"
        >
          {MODEL_LIBRARY_FILTER_ITEMS.map((item) => (
            <TabsItem key={item.value} value={item.value}>
              {item.label}
            </TabsItem>
          ))}
        </Tabs>
      </div>

      <div className={styles["comp__actions"]}>
        <Button
          size="medium"
          variant="primary"
          onClick={() => onAddModelClick?.()}
          startContent={<PlusIcon style={{ width: 20, height: 20 }} />}
        >
          Add new model
        </Button>
      </div>
    </div>
  );
};
